import { render } from "./FadeTransition.vue?vue&type=template&id=5500dd6c"
import script from "./FadeTransition.vue?vue&type=script&lang=js"
export * from "./FadeTransition.vue?vue&type=script&lang=js"

import "./FadeTransition.vue?vue&type=style&index=0&id=5500dd6c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__